import type { LandingComponents } from "@/puck/blocks/blockTypes";
import { ChatMockupBlock } from "@/puck/landing/chatMockupBlock";

const MESSAGE_ROLE_FIELD = {
  type: "radio" as const,
  options: [
    { label: "User", value: "user" },
    { label: "Assistant", value: "assistant" },
  ],
};

const MESSAGE_ARRAY_FIELDS = {
  role: MESSAGE_ROLE_FIELD,
  text: { type: "textarea" as const, contentEditable: true },
  tag: { type: "text" as const, label: "Source tag (assistant only)" },
  citationMarkers: {
    type: "array" as const,
    label: "Citation markers",
    getItemSummary: (item: { index: number }) => `[${item.index}]`,
    defaultItemProps: { index: 1 },
    arrayFields: {
      index: { type: "number" as const, label: "Citation #" },
    },
  },
};

export const chatMockupConfigs: Pick<LandingComponents, "ChatMockup"> = {
  ChatMockup: {
    label: "Chat mockup",
    fields: {
      header: { type: "text" },
      messages: {
        type: "array",
        label: "Messages",
        getItemSummary: (item) =>
          `${item.role === "user" ? "User" : "Assistant"}: ${item.text.slice(0, 40)}`,
        defaultItemProps: {
          role: "user",
          text: "Message text",
          tag: "",
          citationMarkers: [],
        },
        arrayFields: MESSAGE_ARRAY_FIELDS,
      },
      citations: {
        type: "array",
        label: "Citations footer",
        getItemSummary: (item) => `[${item.index}] ${item.label}`,
        defaultItemProps: {
          index: 1,
          label: "Citation source",
          type: "",
        },
        arrayFields: {
          index: { type: "number", label: "Citation #" },
          label: { type: "text", contentEditable: true },
          type: { type: "text", label: "Type (optional)" },
        },
      },
    },
    defaultProps: {
      header: "GailGPT",
      messages: [
        {
          role: "user",
          text: "How many auto policies renew next month?",
          tag: "",
          citationMarkers: [],
        },
        {
          role: "assistant",
          text: "342 policies, $1.2M in premium. 18 are flagged price-sensitive based on Q3 quote shopping.",
          tag: "policies.db",
          citationMarkers: [],
        },
        {
          role: "user",
          text: "Break it down by underwriter.",
          tag: "",
          citationMarkers: [],
        },
      ],
      citations: [],
    },
    render: ChatMockupBlock,
  },
};
